import Api from './Api'

export default{
    create(data, params) {
        return Api.put(`/auth/propertyData/${params}`, data)
    },
    read(params) {
        return Api.get(`/propertyData/${params}`)
    },
    update(params, id, data) {
        return Api.put(`/auth/propertyData/${params}/${id}`, data)
    },
    delete(params, name) {
        return Api.delete(`/auth/propertyData/${params}/${name}`)
    }
}